<template>
  <div class="contact flex flex-col align-center">
    <a aria-label="Call 180 ELDERHelp" href="tel: 1800 353 374">
      1800 ELDERHelp (
      <strong> 1800 353 374 </strong>
      )
    </a>
    <a aria-label="Call 000 in emergency" href="tel: 000" class="emergency">
      In an emergency call 000
    </a>
  </div>
</template>

<style lang="less" scoped>
.contact {
  padding: @gutter-lg 0;

  @media @wide {
    padding: 0;
  }

  a {
    .font-headings();
    .font-md();
    .text-normal();

    strong {
      font-weight: 700;
    }

    &.emergency {
      color: @color-primary;
      margin-top: @gutter-sm;

      @media @wide {
        .hidden();
      }
    }
  }
}
</style>
